import React, { Component } from "react";
import { Widget, addResponseMessage } from "react-chat-widget";
import "react-chat-widget/lib/styles.css";
import "./../assets/sass/chatbot.css";

class ChatbotComponent extends Component {
  componentDidMount() {
    // Pesan awal saat chatbot dibuka
    addResponseMessage(
      "Hi! Welcome to ILI Express. How can I assist you today?"
    );
  }

  handleNewUserMessage = (message) => {
    console.log(`User message: ${message}`);
    // Tangani pesan pengguna
    addResponseMessage(
      "Thank you for your message. We will get back to you shortly."
    );
  };

  render() {
    return (
      <div className="chatbot">
        <Widget
          title="ILI Express Assistant"
          subtitle="Your trusted logistics helper"
          handleNewUserMessage={this.handleNewUserMessage}
          launcherStyle={{
            backgroundColor: "#FFD700", // Warna emas kuning
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)", // Bayangan untuk launcher
          }}
          titleStyle={{
            backgroundColor: "#FFD700", // Header emas kuning
            color: "#000", // Teks hitam
            fontSize: "16px", // Ukuran font judul
            fontWeight: "bold",
          }}
          subtitleStyle={{
            color: "#333", // Warna subtitle gelap
            fontSize: "13px", // Ukuran font subtitle
          }}
        />
      </div>
    );
  }
}

export default ChatbotComponent;
